import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/fiverr_context';
import { HEADER_NAV_SOURCE } from '../../../../constants';
import Link from '../../../Links/Link';

const ContactSupportLink = () => (
    <Link
        href={pathfinder('new_ticket', null, { query: { source: HEADER_NAV_SOURCE } })}
        target="_blank"
        rel="noopener noreferrer"
        className="nav-link"
    >
        <I18n k="header.link_label.contact_support" />
    </Link>
);

export default ContactSupportLink;
